import React from 'react';

import { FIELD_PATHS } from '@funnels/constants';
import { ApplicantEntityIndex } from '@funnels/types';

import { TextAreaField } from '../../Fields';

interface GuarantorRelationshipDescriptionProps extends ApplicantEntityIndex {}
export function GuarantorRelationshipDescription(props: GuarantorRelationshipDescriptionProps) {
  const { applicantIndex } = props;

  return (
    <TextAreaField
      name={FIELD_PATHS.APPLICANT_GUARANTOR_RELATIONSHIP_TO_BORROWER_TYPE_OTHER(applicantIndex)}
      label="Describe the relationship"
      isFullWidth
    />
  );
}
